<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 192 192"
    :fill="isRecording ? '#FF4343' : '#0C9488'"
  >
    <path
      stroke="#FFFFFF"
      :fill="isRecording ? '#FF4343' : '#0C9488'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="8"
      d="M122 48H34c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h88c6.627 0 12-5.373 12-12V60c0-6.627-5.373-12-12-12Zm12 40 36-28v72l-36-28"
    />

    <path
      fill="#FFF"
      d="M49 98a3 3 0 0 0-3 3v24a2.998 2.998 0 0 0 3 3 2.999 2.999 0 0 0 3-3v-4.758l6.879 6.879a2.998 2.998 0 1 0 4.242-4.242l-7.09-7.09c4.435-.54 7.97-4.219 7.97-8.789 0-4.935-4.066-9-9-9H49Zm26 0c-3.278 0-6 2.722-6 6v18c0 3.278 2.722 6 6 6h9a2.999 2.999 0 0 0 2.121-5.121A2.999 2.999 0 0 0 84 122h-9v-6h3a2.999 2.999 0 0 0 2.121-5.121A2.999 2.999 0 0 0 78 110h-3v-6h9a2.999 2.999 0 0 0 2.121-5.121A3 3 0 0 0 84 98h-9Zm26 0c-4.935 0-9 4.065-9 9v12c0 4.935 4.065 9 9 9h6c.796 0 1.559-.316 2.121-.879a2.996 2.996 0 0 0 0-4.242A2.996 2.996 0 0 0 107 122h-6c-1.692 0-3-1.308-3-3v-12c0-1.692 1.308-3 3-3h6c.796 0 1.559-.316 2.121-.879a2.996 2.996 0 0 0 0-4.242A2.998 2.998 0 0 0 107 98h-6Zm-49 6h3c1.692 0 3 1.308 3 3s-1.308 3-3 3h-3v-6Z"
    />
  </svg>
</template>
<script>
export default {
  props: {
    isRecording: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
